module.exports = __webpack_public_path__ + "img/NextAdmin2.d492108d.svg";